import {query} from "@/graphql/client";
import {gql} from "@urql/vue";
import {EmployeeMonthSummary, MonthKpi} from "@/graphql/generated/graphql";
import {kapitelDateString, kapitelMonthString} from "@/graphql/kapitelTypes";
import {graphql} from "@/graphql/generated";

export const employeeMonthSummary = graphql(`fragment EmployeeMonthSummaryFragment on EmployeeMonthSummary {
    month
    
    bookingTarget
    cntAZKDays
    cntBookings
    cntSicknessDays
    cntVacationDays
    productiveHours
}`)


export async function fetchEmployeeMonthSummary(month: kapitelMonthString): Promise<EmployeeMonthSummary> {
    const result = await query(
        graphql(`query getEmployeeMonthSummary($month: KapitelDateImmutable!) {            
            employeeMonthSummary(month: $month) {
                ...EmployeeMonthSummaryFragment
            }
        }`),
        {month}
    )

    return result.data.employeeMonthSummary
}

export async function fetchEmployeeMonthSummaries(begin: kapitelMonthString, until: kapitelMonthString): Promise<EmployeeMonthSummary[]> {
    const result = await query(
        graphql(`query getEmployeeMonthSummaries($begin: KapitelDateImmutable!, $until: KapitelDateImmutable!) {            
            employeeMonthSummaries(begin: $begin, until: $until) {
                ...EmployeeMonthSummaryFragment
            }
        }`),
        {begin, until}
    )

    return result.data.employeeMonthSummaries
}
